// extracted by mini-css-extract-plugin
export var station_crew__container = "station-crew-module--station_crew__container--3r1xN";
export var station_crew__desktop_profile = "station-crew-module--station_crew__desktop_profile--3Q7ue";
export var station_crew__mobile_profile = "station-crew-module--station_crew__mobile_profile--Kpw6-";
export var station_crew__mobile_image = "station-crew-module--station_crew__mobile_image--1dCyM";